<template>
  <el-dialog title="要素总览表" :visible="showOverview" :close-on-click-modal="false" @close="closeDialog">
    <div class="legend">
      <div :class="'item level' + item.dicCode" v-for="(item, index) in riskLevelList" :key="index">
        <div class="line"></div>
        <p>{{ item.dicValue }}</p>
      </div>
    </div>
    <el-table class="global-table doubleTitle" v-loading="loading" :data="list" :max-height="1000" size="medium" border>
      <el-table-column label="巡查对象" prop="elementName" align="center" min-width="140">
        <template v-slot="{ row }">
          <div class="buttonStyle elementButtonStyle">
            <div>
              <i class="iconfont icon-xunchaduixiang"></i>
              {{ row.elementName }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column class-name="standardList" label="检查标准要素" prop="standardList" min-width="220" align="center">
        <template v-slot="{ row }">
          <template v-for="item in row.standardList">
            <p class="preWrap" :key="item.standardId">{{ item.standardContent }}</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="管控措施" prop="controlMeasures" min-width="200" align="center">
        <template v-slot="{ row }">
          <p class="preWrap">{{ row.controlMeasures || '' }}</p>
        </template>
      </el-table-column>
      <el-table-column label="建议巡查频次" prop="corpFrequency" align="center">
        <el-table-column prop="corpFrequencyType" label="管理抽查" width="110" align="center">
          <template v-slot="{ row }">
            <span class="buttonStyle">{{ row.corpFrequency || 1 }}次/{{ [1, 2, 3].includes(row.corpFrequencyType) ?
              cycleList[row.corpFrequencyType - 1] : '日' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cooperateFrequencyType" label="项目自查" width="110" align="center">
          <template v-slot="{ row }">
            <span class="buttonStyle">{{ row.cooperateFrequency || 1 }}次/{{ [1, 2,
              3].includes(row.cooperateFrequencyType)
              ? cycleList[row.cooperateFrequencyType - 1] : '日' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="巡查方式" prop="patrolType" align="center" width="100">
        <template>
          <span>
            <i class="iconfont icon-andianxuncha"></i>
            按点巡查
          </span><br>
          <span>
            <i class="iconfont icon-anxianxuncha"></i>
            按线巡查
          </span>
        </template>
      </el-table-column>
      <el-table-column label="风险等级" prop="riskLevelName" align="center" width="110">
        <template v-slot="{ row }">
          <span :class="'levelButton level' + row.riskLevel">{{ row.riskLevelName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="应急处置建议" prop="emergencyDisposal" min-width="200" align="center">
        <template v-slot="{ row }">
          <p class="preWrap">{{ row.emergencyDisposal || '' }}</p>
        </template></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  name: 'ElementOverview',
  props: {
    showOverview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cycleList: ['日', '周', '月'],
      riskLevelList: [],
      list: [],
      loading: false
    }
  },
  watch: {
    showOverview(val) {
      if (val) {
        this.loadData()
      }
    }
  },
  created() {
    this.loadRiskLevelList()
  },
  methods: {
    loadRiskLevelList() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        dicType: 'riskLevel'
      }).then(res => {
        this.riskLevelList = res.riskLevel || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.patrol.selectElementViewList).then(res => {
        this.list = res || []
      }).finally(() => {
        this.loading = false
      })
    },
    // 关闭
    closeDialog() {
      this.$emit('update:showOverview', false)
    }
  }
}
</script>

<style scoped lang="scss">
.legend {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .item {
    width: 20%;

    .line {
      width: 100%;
      height: 8px;
    }

    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-align: center;
      line-height: 20px;
      margin-top: 8px;
    }
  }
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;

  ::v-deep .el-dialog {
    width: calc(100vw - 250px);
    height: calc(100vh - 90px);
    margin: 90px 0 0 250px !important;

    .el-dialog__header {
      width: 100%;
      height: 62px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
      line-height: 22px;
      background: linear-gradient(180deg, #ECEEF3 0%, #F6F7FB 56%, #E8EAF0 100%);
      border-radius: 4px 4px 0px 0px;
      border-width: 0;

      .el-dialog__title {
        color: #222;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        line-height: 62px;
        height: 62px;
      }

      .el-dialog__close {
        color: #333333;
      }
    }

    .el-table {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 400;
      color: #333333;
      max-height: calc(100vh - 268px) !important;

      td.el-table__cell {
        border-color: #EAEEF5 !important;
      }

      th.el-table__cell {
        background: #BFCED6 !important;
      }

      tr.el-table__row:hover {

        &,
        td {
          background: #E8EAF0 !important;
        }
      }

      .el-table__header th {
        line-height: 28px;
      }

      .el-table__body-wrapper {
        max-height: calc(100vh - 316px) !important;

        .iconfont {
          font-size: 12px;
          color: #5588A3;
        }

        .buttonStyle {
          display: inline-block;
          width: auto;
          height: auto;
          line-height: 20px;
          background: #F9F9F9;
          border-radius: 4px;
          border: 1px solid #D9D9D9;
          padding: 6px 16px;
        }

        .elementButtonStyle {
          background: #F8FCFE;
          border: 1px solid #D3DBE0;

          &>div {
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;

            .iconfont {
              flex-shrink: 0;
              margin-right: 4px;
            }
          }
        }

        .standardList {

          &,
          * {
            padding: 0 !important;
          }

          .cell {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }

          p {
            padding: 8px 10px !important;

            &:not(:last-child) {
              border-bottom: 1px solid #eaeef5;
            }
          }
        }

        .preWrap {
          white-space: pre-wrap;
          text-align: left;
        }
      }

      &.doubleTitle .el-table__body-wrapper {
        max-height: calc(100vh - 364px) !important;
      }
    }
  }
}

.levelButton {
  display: inline-block;
  width: auto;
  height: auto;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 20px;
  border-radius: 4px;
  padding: 6px 16px;
}

.level0 {
  color: #93C41A;

  .line {
    background: #93C41A;
  }

  &.levelButton {
    background: #93C41A20;
  }
}

.level1 {
  color: #FFC90C;

  .line {
    background: #FFC90C;
  }

  &.levelButton {
    background: #FFC90C20;
  }
}

.level2 {
  color: #FF8412;

  .line {
    background: #FF8412;
  }

  &.levelButton {
    background: #FF841220;
  }
}

.level3 {
  color: #FF1313;

  .line {
    background: #FF1313;
  }

  &.levelButton {
    background: #FF131320;
  }
}

.level4 {
  color: #9D0000;

  .line {
    background: #9D0000;
  }

  &.levelButton {
    background: #9D000020;
  }
}
</style>
